import { api } from './client';
import type { AxiosResponse } from 'axios';

export interface AlertThresholds {
  disk_percent: number;
  ram_percent: number;
  load_multiplier: number;
  disk_duration_min: number;
  ram_duration_min: number;
  load_duration_min: number;
  hysteresis_min: number;
  throttle_min: number;
}

export const fetchThresholds = (): Promise<AlertThresholds> =>
  api.get<AlertThresholds>('/alerts/thresholds').then((r: AxiosResponse<AlertThresholds>) => r.data);

export const updateThresholds = (data: Partial<AlertThresholds>): Promise<AlertThresholds> =>
  api.patch<AlertThresholds>('/alerts/thresholds', data).then((r: AxiosResponse<AlertThresholds>) => r.data);

export const testAlert = (metric: 'disk' | 'ram' | 'load'): Promise<void> =>
  api.post(`/alerts/test/${metric}`).then(() => undefined);
